export let today = new Date();
import { getTime, regexErrors, regexes, regexPlaceholders } from "./helper.js";
export let time = getTime(today.getHours(), today.getMinutes());
export let data = {
  title: "Input Hasil Triase",
  backBtn: "/ugd",
  actionBtn: [],
  breadcrumb: [
    { title: "UGD", link: "/ugd" },
    { title: "Detail UGD", link: "/ugd" },
    { title: "Input Hasil Triase", active: true },
  ],
};
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" },
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)",
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)",
        },
      ],
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat",
        },
      ],
    },
  ],
};

export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "confirmation_number",
        colwidth: 6,
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "apps",
        colwidth: 6,
      },
    ],
  },
];
export let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps",
  },
];
export let upperForm = [
  {
    colnum: 3,
    columns: [
      {
        label: "Tanggal Periksa",
        type: "date",
        placeholder: "Pilih tanggal periksa",
        name: "tgl_periksa",
        value: today,
        mandatory: true,
        additional: "",
        colwidth: "3",
      },
      {
        label: "Jam",
        type: "time",
        placeholder: "jj:mm",
        name: "jam_periksa",
        value: time,
        mandatory: true,
        additional: "",
        colwidth: "2",
      },
      {
        label: "Dokter Tugas",
        type: "select",
        placeholder: "Dokter Tugas",
        name: "id_dokter",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "D0000026 | dr. Azizah Masthura",
            value: "D0000026",
          },
        ],
        additional: "",
        colwidth: 4,
      },
    ],
  },
];
export let formKeluhan = [
  {
    colnum: 1,
    columns: [
      {
        label: "Keluhan Utama",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "Masukkan keluhan utama di sini",
        name: "keluhan_utama",
        value: "",
        mandatory: true,
        additional: "",
      },
    ],
  },
];
export let formVital = [
  {
    colnum: 3,
    columns: [
      {
        label: "GCS",
        type: "addon-left",
        addon: "E",
        placeholder: "",
        name: "gcs_e",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: " ",
        type: "addon-left",
        addon: "V",
        placeholder: "",
        name: "gcs_v",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: " ",
        type: "addon-left",
        addon: "M",
        placeholder: "",
        name: "gcs_m",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 3,
    columns: [
      {
        label: "Pupil",
        type: "addon-right",
        addon: "mm2",
        placeholder: "",
        name: "pupil_luas",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: " ",
        type: "addon-right",
        addon: "mm",
        placeholder: "",
        name: "pupil_panjang",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: "Reflek Cahaya",
        type: "text",
        placeholder: ``,
        name: "reflek_cahaya",
        value: ``,
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "Suhu Badan",
        type: "addon-right",
        addon: "°C",
        regex: regexes.suhu,
        regexError: regexErrors.suhu,
        placeholder: regexPlaceholders.suhu,
        name: "suhu",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: "Tekanan Darah",
        type: "addon-right",
        addon: "mmhg",
        addonType: "text",
        regex: regexes.tkn_darah,
        regexError: regexErrors.tkn_darah,
        placeholder: regexPlaceholders.tkn_darah,
        name: "tkn_darah",
        value: ``,
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 3,
    columns: [
      {
        label: "Nadi",
        type: "addon-right",
        addon: "x/menit",
        regex: regexes.nadi,
        regexError: regexErrors.nadi,
        placeholder: regexPlaceholders.nadi,
        name: "nadi",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: "Respirasi",
        type: "addon-right",
        addon: "x/menit",
        regex: regexes.respirasi,
        regexError: regexErrors.respirasi,
        placeholder: regexPlaceholders.respirasi,
        name: "respirasi",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: "SpO2",
        type: "percentage",
        placeholder: "",
        name: "spo2",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "radio",
        addon: "mg/dL",
        name: "reguler",
        value: "",
        mandatory: true,
        options: [
          { label: "Reguler", value: "1" },
          { label: "Ireguler", value: "0" },
        ],
        colwidth: "4",
      },
    ],
  },
];
export let formSosial = [
  {
    colnum: 1,
    columns: [
      {
        label: "Pekerjaan",
        type: "radio",
        placeholder: "",
        name: "pekerjaan",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Wiraswasta",
            value: "1",
          },
          {
            label: "PNS",
            value: "2",
          },
          {
            label: "Pensiunan",
            value: "3",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Interaksi Sosial",
        type: "checkbox_old",
        placeholder: "",
        name: "interaksi_sosial",
        value: [],
        mandatory: false,
        optional: true,
        multiple: false,
        options: [
          {
            label: "Mahasiswa",
            value: "1",
          },
          {
            label: "Mengikuti acara di sekitar rumah",
            value: "2",
          },
        ],
        additional: "",
      },
    ],
  },
];
export let formPsikologis = [
  {
    colnum: 1,
    columns: [
      {
        label: "STATUS PSIKOLOGIS",
        type: "checkbox_old",
        class: "block",
        placeholder: "",
        name: "status_psikologis",
        value: [],
        mandatory: false,
        optional: true,
        multiple: false,
        options: [
          {
            label: "Takut terhadap terapi/pembedahan/lingkungan RS",
            value: "1",
          },
          {
            label: "Sedih",
            value: "2",
          },
          {
            label: "Marah/tegang",
            value: "3",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "GANGGUAN PERILAKU",
        type: "radio",
        class: "",
        placeholder: "",
        name: "gangguan_perilaku",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Tidak terganggu",
            value: "0",
          },
          {
            label: "Ada gangguan",
            value: "1",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        type: "radio",
        class: "",
        placeholder: "",
        name: "gangguan_perilaku_bahaya",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Tidak membahayakan",
            value: "0",
          },
          {
            label: "Membahayakan diri sendiri/orang lain",
            value: "1",
          },
        ],
        additional: "",
      },
    ],
  },
];
export let formAlergi = [
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "radio",
        placeholder: "",
        name: "status_alergi",
        value: "",
        mandatory: false,
        multiple: false,
        options: [
          {
            label: "Tidak",
            value: "0",
          },
          {
            label: "Ya, sebutkan",
            value: "1",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Alergi",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder:
          "Isi jika memiliki alergi. Cukup isi - jika tidak memiliki alergi",
        name: "alergi",
        mandatory: false,
        optional: true,
        value: "",
        additional: "",
      },
    ],
  },
];
export let formTriase = [
  {
    colnum: 1,
    columns: [
      {
        label: "Skala Triase",
        type: "radio",
        placeholder: "",
        name: "skala_triase",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          { value: 1, label: 1 },
          { value: 2, label: 2 },
          { value: 3, label: 3 },
          { value: 4, label: 4 },
          { value: 5, label: 5 },
        ],
        additional: "",
      },
    ],
  },
];
